/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Component, Input } from '@angular/core';
import { Color } from '@ionic/core';

@Component({
  selector: 'app-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrls: ['./alert-message.component.scss']
})
export class AlertMessageComponent {
  /**
   * colore avviso
   */
  @Input() color: Color = 'warning';

  /**
   * icona
   */
  @Input() icon = 'alert-circle-outline';

  /**
   * titolo
   */
  @Input() title: string;

  /**
   * messaggio
   */
  @Input() message: string;
}
